import script from "./GameBuilderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameBuilderPage.vue?vue&type=script&setup=true&lang=ts"

import "./GameBuilderPage.vue?vue&type=style&index=0&id=93fee96a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93fee96a"]])

export default __exports__